import { WizardStep, WizardStepIndex } from "../../../shared/enums/WizardStep";
import { linkHelper } from "../../../shared/helpers/linkHelper";
import StepActive from "./StepActive";
import StepDone from "./StepDone";
import StepInactive from "./StepInactive";

interface ContactUsStepItemProps {
  activeStepIndex: number;
  market: string;
  text: string;
}

const ContactUsStepItem = ({
  activeStepIndex,
  market,
  text,
}: ContactUsStepItemProps) => {
  const stepNumber = WizardStepIndex.ContactUs + 1;
  const hideMobile =
    activeStepIndex < WizardStepIndex.Optional ? "hideStep" : "";

  if (activeStepIndex === WizardStepIndex.ContactUs) {
    return (
      <StepActive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  if (activeStepIndex < WizardStepIndex.ContactUs) {
    return (
      <StepInactive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  const url = linkHelper.link(WizardStep.ContactUs, market);
  return <StepDone hideMobilClass={hideMobile} text={text} url={url} />;
};

export default ContactUsStepItem;
